import { Component } from '@angular/core';

import { Angulartics2AppInsights } from 'angulartics2/appinsights';
import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';
import { Angulartics2Mixpanel } from 'app/analytics/angulartics2-mixpanel';
import { Angulartics2Marketo } from 'app/analytics/angulartics2-marketo';
import smoothscroll from 'smoothscroll-polyfill';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent {
    constructor(
        angulartics2AppInsights: Angulartics2AppInsights,
        angulartics2GoogleTagManager: Angulartics2GoogleTagManager,
        angulartics2Marketo: Angulartics2Marketo,
        angulartics2Mixpanel: Angulartics2Mixpanel) {
        angulartics2GoogleTagManager.startTracking();
        smoothscroll.polyfill();
    }
}
